import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Fetches the approval status and decision history for a discount.
 * Useful for displaying approval timeline in the UI.
 */
export function useGetDiscountApprovalStatus(discountId: string | undefined) {
  return useQuery({
    ...orpc.accountsReceivable.discounts.getApprovalStatus.queryOptions({
      input: { discountId: discountId ?? '' },
    }),
    enabled: !!discountId,
  });
}
